<template>
    <div
        class="flex !w-full items-center justify-center"
        data-spec-class="summary-user"
    >
        <div class="rounded-sm bg-gray-700 px-12 py-6 text-white shadow-sm lg:w-1/2">
            <UserInfoLoggedIn
                :user-name="userName"
                :redirect-params="redirectParams"
            />

            <SummaryGroups :summary-groups="summaryGroups"></SummaryGroups>
            <SummaryPrices
                :summary-groups="summaryGroups"
                :monthly-price="monthlyPrice"
                :setup-price="setupPrice"
            ></SummaryPrices>

            <form @submit.prevent="onSubmit">
                <div class="mt-6 flex justify-center gap-3">
                    <Confirm :disabled="sendingStatus.busy || sendingStatus.success">
                        <BaseSpinner
                            :is-active="sendingStatus.busy || sendingStatus.success"
                            class="mr-0.5"
                        />
                        <ConfirmationOrderButton
                            :selection="selection"
                            :type="type"
                        />
                    </Confirm>
                </div>
            </form>
        </div>
    </div>
</template>

<script setup>
import { defineProps, reactive } from 'vue';
import SummaryGroups from './SummaryGroups.vue';
import SummaryPrices from './SummaryPrices.vue';
import Confirm from './Confirm.vue';
import { currentUrlWithPathSuffix, UseFormSubmit } from '../../functions/useFormSubmit';
import UserInfoLoggedIn from '../UserInfoLoggedIn.vue';
import ConfirmationOrderButton from '../ConfirmationOrderButton.vue';

const props = defineProps({
    summaryGroups: { type: Array, default: () => [] },
    userName: { type: String, default: '' },
    type: { type: String, required: true },
    monthlyPrice: { type: Number, required: true },
    setupPrice: { type: Number, required: true },
    mailSummary: { type: Object, required: true },
    selection: { type: Object, required: true },
    redirectParams: { type: String, default: '' },
});

const submitData = reactive({
    configuration: props.mailSummary,
    type: props.type,
    price: props.monthlyPrice,
    setupPrice: props.setupPrice,
    selection: props.selection,
    lang: document.documentElement.lang,
});

const { send, sendingStatus } = UseFormSubmit(
    currentUrlWithPathSuffix(props.urlModifier),
    submitData
);

const onSubmit = async () => {
    try {
        await send();
        window.location.href = `/thank-you?type=${props.type}&price=${props.monthlyPrice}`;
    } catch (error) {
        console.error(error);
    }
};
</script>
